<script lang="ts" setup>
import ErrorMessage from '@/components/ErrorMessage.vue'
import Loading from '@/components/Loading.vue'
import {
  consumePostLoginRedirect,
  safeRedirectPath,
} from '@/lib/safeRedirectPath'
import { useAuthStore } from '@/stores/auth'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const hasError = ref(false)
const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

const redirectTo = safeRedirectPath(route.query.redirect_to)

authStore
  .authenticate(route.query.token as string | undefined)
  .then(() => {
    if (authStore.isAuthenticated) {
      router.replace(redirectTo ?? consumePostLoginRedirect() ?? '/')
    } else {
      hasError.value = true
    }
  })
  .catch(() => {
    hasError.value = true
  })
</script>

<template>
  <div v-if="!hasError" class="AppLoadingState">
    <Loading />
  </div>
  <div v-else>
    <ErrorMessage>
      <template #title>Something's up</template>
      Sorry, we can't show you your account right now. Please try again shortly.
    </ErrorMessage>
  </div>
</template>
